export default {"src":"/_next/static/media/icon-flower.cdc89b77.svg","height":32,"width":32};